module.exports = __webpack_public_path__ + "assets/img/23_24.4dd504e3.jpg";